import Application from "../../Application";

export default function() {
    Application.Common.manageCommissionsTable();

    $(document).on('click', '.active-user', function(){
        $.ajax({
            'url': '/ajax/active-user',
            'method': 'POST',
            'data': {
                'active' : $('.active-user').data('active'),
                'user_id' : $('[name="user_id"]').val(),
            },
            beforeSend: function(){
                $('.loader-container').removeClass('d-none');
            },
            success: function(response){
                if(response.success){
                    $('.active-user').data('active', !$('.active-user').data('active'));
                    if($('.active-user').hasClass('remove-user')){
                        $('.active-user').removeClass('remove-user');
                        $('.active-user').html('Attiva');
                        $('.label-status').removeClass('active');
                        $('.label-status').html('bloccato');
                        Swal.fire({
                            title: 'Operazione riuscita',
                            text: 'Hai disattivato correttamente l\'account di ' + $('.admin-title').text(),
                            icon: 'success',
                        });
                    } else {
                        $('.active-user').addClass('remove-user');
                        $('.active-user').html('Disattiva');
                        $('.label-status').addClass('active');
                        $('.label-status').html('attivo');
                        Swal.fire({
                            title: 'Operazione riuscita',
                            text: 'Hai attivato correttamente l\'account di ' + $('.admin-title').text(),
                            icon: 'success',
                        });
                    }
                } else {
                    Swal.fire({
                        title: 'Si è verificato un problema',
                        text: 'Lo stato dell\' utente non è stata aggiornata correttamente, si prega di ripetere l\'operazione',
                        icon: 'error',
                    });
                }
                $('.loader-container').addClass('d-none');
            },
            error: function(){
                $('.loader-container').addClass('d-none');
                Swal.fire({
                    title: 'Si è verificato un problema',
                    text: 'Lo stato dell\' utente non è stata aggiornata correttamente, si prega di ripetere l\'operazione',
                    icon: 'error',
                });
            }
        });
    });
}